import './QuestionsEvaluation.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { QuestionEvaluationType } from './types/QuestionEvaluationType';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

interface QuestionsEvaluationProps {
  questionsEvaluation: QuestionEvaluationType[] | null;
}

const QuestionsEvaluation: React.FC<QuestionsEvaluationProps> = ({ questionsEvaluation }) => {
  const { t } = useTranslation();

  if (!questionsEvaluation) {
    return <></>;
  }

  return (
    <div className="stats__panel">
      <div className="page-box__title-action">
        <div className="page-box__title page-box__title--flex">
          {t('insightPage.questionsEvaluation')}
        </div>
      </div>
      <DataTable
        stripedRows
        paginator={true}
        scrollable
        paginatorClassName="pagination"
        removableSort
        value={questionsEvaluation}
        rows={10}
        // emptyMessage={emptyTemplate}
        rowsPerPageOptions={[10, 25, 50]}
        tableStyle={{ minWidth: '50rem', tableLayout: 'auto' }}
        tableClassName="table"
        className="table-wrapper"
        currentPageReportTemplate={t('rowsNumber') + ':'}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      >
        <Column
          header={t('status')}
          field="status"
          headerClassName="table__header"
          body={(data) => (
            <div className={`status status--${data.status.toLowerCase()}`}>
              <div className="status__ring" />
              <div className="status__dot" />
            </div>
          )}
          style={{ width: '37px' }}
        />
        <Column
          header={t('prompt')}
          field="prompt"
          headerClassName="table__header"
          body={(data) => <>Jakie są alternatywy dla Sky-Shop?</>}
          style={{ minWidth: '300px', maxWidth: '380px' }}
        />
        <Column
          header={t('analysis')}
          field="analysis"
          headerClassName="table__header"
          style={{ minWidth: '300px', maxWidth: '380px' }}
        />
        <Column
          header={t('reasoning')}
          field="reasoning"
          headerClassName="table__header"
          style={{ minWidth: '260px' }}
        />
      </DataTable>
    </div>
  );
};

export default QuestionsEvaluation;
